fragment DomainFragment on Domain {
    id
    name
    emailDeliverabilityStatus
    hostingTrackingStatus
    canUseEntriSetup
    groupSpf {
        type
        name
        status
        records {
            type
            record
            value
            priority
            status
            errorMessage
        }
    }
    groupDkim {
        type
        name
        status
        records {
            type
            record
            value
            priority
            status
            errorMessage
        }
    }
    groupCustom {
        type
        name
        status
        records {
            type
            record
            value
            priority
            status
            errorMessage
        }
    }
    groupDmarc {
        type
        name
        status
        records {
            type
            record
            value
            priority
            status
            errorMessage
        }
    }
}
